// снижение прозрачности меню при прокрутке страницы вниз
const menuOpacity = function() {
  const opacityRange = 500;

  const el = document.querySelector('.fixed-menu');
  const scrollTop = window.scrollY || document.documentElement.scrollTop;

  el.style.setProperty( '--menu-bg-gradient-step', (scrollTop / opacityRange < 1) ? Math.ceil( ( scrollTop / opacityRange ) * 100 ) + '%' : '100%' );
}


const toggleMenu = function() {
  const menu = document.querySelector('.main-menu__wrapper');
  const el = document.querySelector('.fixed-menu');

  if (!menu.classList.contains('main-menu__visible-mobile')) {
    menu.classList.add('main-menu__visible-mobile');
    // сделать градиент верхнего меню полностью прозрачным при открытом мобильном меню
    // прозрачность регулируется декоративным элементом самого мобильного меню
    el.style.setProperty( '--menu-bg-gradient-begin-disabled', 'rgba( 0, 0, 0, 0 )' );
    el.style.setProperty( '--menu-bg-gradient-end-disabled', 'rgba( 0, 0, 0, 0 )' );
  } else {
    menu.classList.remove('main-menu__visible-mobile');
    el.style.removeProperty( '--menu-bg-gradient-begin-disabled' );
    el.style.removeProperty( '--menu-bg-gradient-end-disabled' );
  }

}

// открытие/закрытие подменю в мобильном режиме
const toggleSubMenu = function( ev ) {

  ev.stopPropagation();

  const subMenuButton = ev.target;
  const menuItem = subMenuButton.closest( '.menu-item' );

  // открыто-ли меню, или его подменю?
  const menuItemOpened = menuItem.classList.contains( 'menu-mobile-item_custom-opened' )
    || menuItem.querySelectorAll( 'menu-mobile-item_custom-opened ' ).length > 0;

  // закрыть все открытые подменю
  const menuItems = menuItem.parentElement.querySelectorAll( '.menu-item' );
  menuItems.forEach( menuItem => menuItem.classList.remove( 'menu-mobile-item_custom-opened' ) );

  // если не было открыто - открыть подменю
  if ( ! menuItemOpened ) {
    menuItem.classList.add( 'menu-mobile-item_custom-opened' );
  };
}


const hideMenu = function() {
  toggleMenu();
}


document.addEventListener('DOMContentLoaded', function() {

  menuOpacity();
  window.addEventListener('scroll', menuOpacity);

  const menuButton = document.querySelector('.main-menu__button');
  const menu = document.querySelector('.main-menu__list-wrapper');

  menuButton.addEventListener('click', toggleMenu);
  menu.addEventListener('click', hideMenu);

  const subMenuButtons = document.querySelectorAll('.main-menu__submenu-button');
  subMenuButtons.forEach( subMenuButton => subMenuButton.addEventListener('click', toggleSubMenu) );

})
